// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"490":"638871b2","868":"5e67146d"}[chunkId] + ".css";
};